import { TruncatedText } from "@spz/ui/components/truncated-text";
import { cn } from "@spz/ui/lib/utils";
import { Link } from "react-router-dom";
import type { LinkCellProps } from "../types";

export const LinkCell: React.FC<LinkCellProps> = ({
  value,
  to,
  maxLines = 2,
  className,
  showTooltip = true,
  "data-testid": dataTestId,
}) => {
  const content = (
    <Link
      to={to}
      className={cn(
        "text-body font-base",
        "cursor-pointer hover:underline hover:text-blue-800",
        "whitespace-normal break-words overflow-hidden",
        className,
      )}
      data-testid={dataTestId}
    >
      {value}
    </Link>
  );

  return showTooltip ? (
    <TruncatedText maxLines={maxLines} content={value}>
      {content}
    </TruncatedText>
  ) : (
    content
  );
};
